// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMap$dOrdered from "../Data.Map.Ordered/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple$dT2 from "../Data.Tuple.T2/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dI18n$dTypes from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic$dLocales from "../Restaumatic.Locales/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dAvailability from "../Restaumatic.Menu.V2.Types.Availability/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric from "../Restaumatic.Menu.V2.Types.Parametric.Parametric/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dPhoto from "../Restaumatic.Menu.V2.Types.Photo/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const eq1 = /* #__PURE__ */ (() => Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.eqParametric(Data$dEq.eqBoolean).eq)();
const eq2 = /* #__PURE__ */ (() => Data$dMap$dInternal.eqMap(Restaumatic$dLocales.eqLocale)(Data$dEq.eqString).eq)();
const availabilityIsSymbol = {reflectSymbol: () => "availability"};
const availableWhenIsSymbol = {reflectSymbol: () => "availableWhen"};
const nameIsSymbol = {reflectSymbol: () => "name"};
const photoIsSymbol = {reflectSymbol: () => "photo"};
const showTranslated = /* #__PURE__ */ Data$dMap$dInternal.showMap(Restaumatic$dLocales.showLocale)(Data$dShow.showString);
const CustomParameterChoiceIsSymbol = {reflectSymbol: () => "CustomParameterChoice"};
const decodeRecordCons = /* #__PURE__ */ Unscramble.decodeRecordCons(nameIsSymbol)(/* #__PURE__ */ Restaumatic$dI18n$dTypes.decodeMap(Unscramble.decodeString1));
const adminNoteIsSymbol = {reflectSymbol: () => "adminNote"};
const choicesIsSymbol = {reflectSymbol: () => "choices"};
const defaultChoiceIsSymbol = {reflectSymbol: () => "defaultChoice"};
const divisibleIsSymbol = {reflectSymbol: () => "divisible"};
const CustomParameterIsSymbol = {reflectSymbol: () => "CustomParameter"};
const encodeWithOptionsOther = /* #__PURE__ */ (() => {
  const encode1 = Restaumatic$dI18n$dTypes.encodeTranslated(Foreign$dGeneric$dClass.stringEncode).encode;
  return {encodeWithOptions: v => encode1};
})();
const encodeWithOptionsOther1 = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const decodeWithOptionsOther = /* #__PURE__ */ (() => {
  const decode2 = Restaumatic$dI18n$dTypes.decodeTranslated(Foreign$dGeneric$dClass.stringDecode).decode;
  return {decodeWithOptions: v => decode2};
})();
const decodeWithOptionsOther1 = {decodeWithOptions: v => Foreign$dGeneric$dClass.booleanDecode.decode};
const CustomParameterChoice = x => x;
const CustomParameter = x => x;
const toFillFormTypeCustomParam = {fillFormDataType: v => "unknown"};
const toFillFormTypeCustomParam1 = {fillFormDataType: v => "unknown"};
const newtypeCustomParameter_ = {Coercible0: () => {}};
const newtypeCustomParameterCho = {Coercible0: () => {}};
const hasFieldCustomParameterCh = dictHasField => dictHasField;
const hasFieldCustomParameter = dictHasField => dictHasField;
const eqCustomParameterChoice = {
  eq: x => y => (() => {
    if (x.availability.tag === "Available") { return y.availability.tag === "Available"; }
    if (x.availability.tag === "TemporarilyUnavailable") { return y.availability.tag === "TemporarilyUnavailable"; }
    if (x.availability.tag === "Hidden") { return y.availability.tag === "Hidden"; }
    return false;
  })() && eq1(x.availableWhen)(y.availableWhen) && eq2(x.name)(y.name) && (() => {
    if (x.photo.tag === "Nothing") { return y.photo.tag === "Nothing"; }
    if (x.photo.tag === "Just") {
      if (y.photo.tag === "Just") { return x.photo._1 === y.photo._1; }
      return false;
    }
    return false;
  })()
};
const eq7 = /* #__PURE__ */ (() => Data$dMap$dOrdered.eqOMap(Data$dEq.eqString)(eqCustomParameterChoice).eq)();
const eqCustomParameter = {
  eq: x => y => x.adminNote === y.adminNote && eq7(x.choices)(y.choices) && (() => {
    if (x.defaultChoice.tag === "Nothing") { return y.defaultChoice.tag === "Nothing"; }
    if (x.defaultChoice.tag === "Just") {
      if (y.defaultChoice.tag === "Just") { return x.defaultChoice._1 === y.defaultChoice._1; }
      return false;
    }
    return false;
  })() && x.divisible === y.divisible && eq2(x.name)(y.name)
};
const genericCustomParameterChoice = {to: x => x, from: x => x};
const showCustomParameterChoice = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.showParametric(Data$dShow.showBoolean);
      return {
        genericShowArgs: v => [
          "{ availability: " + Restaumatic$dMenu$dV2$dTypes$dAvailability.showAvailability.show(v.availability) + ", availableWhen: " + $0.show(v.availableWhen) + ", name: " + showTranslated.show(v.name) + (() => {
            if (v.photo.tag === "Just") { return ", photo: (Just " + Restaumatic$dMenu$dV2$dTypes$dPhoto.showPhoto.show(v.photo._1) + ") "; }
            if (v.photo.tag === "Nothing") { return ", photo: Nothing "; }
            $runtime.fail();
          })() + "}"
        ]
      };
    })())(CustomParameterChoiceIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeCustomParameterChoice = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(availabilityIsSymbol)(Restaumatic$dMenu$dV2$dTypes$dAvailability.unscrambleDecodeAvailability)(Unscramble.decodeRecordCons(availableWhenIsSymbol)(Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.udecodeParametric(Unscramble.decodeBoolean1))(decodeRecordCons(Unscramble.decodeRecordCons(photoIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dMenu$dV2$dTypes$dPhoto.unscrambleDecodePhoto))(Unscramble.decodeRecordNil)))).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericCustomParameter = {to: x => x, from: x => x};
const showCustomParameter = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dMap$dOrdered.showOMap(Data$dUUID.showUUID)(showCustomParameterChoice);
      return {
        genericShowArgs: v => [
          "{ adminNote: " + Data$dShow.showStringImpl(v.adminNote) + ", choices: " + $0.show(v.choices) + (() => {
            if (v.defaultChoice.tag === "Just") {
              return ", defaultChoice: (Just " + v.defaultChoice._1 + ")" + (v.divisible
                ? ", divisible: true, name: " + showTranslated.show(v.name) + " "
                : ", divisible: false, name: " + showTranslated.show(v.name) + " ");
            }
            if (v.defaultChoice.tag === "Nothing") {
              if (v.divisible) { return ", defaultChoice: Nothing, divisible: true, name: " + showTranslated.show(v.name) + " "; }
              return ", defaultChoice: Nothing, divisible: false, name: " + showTranslated.show(v.name) + " ";
            }
            $runtime.fail();
          })() + "}"
        ]
      };
    })())(CustomParameterIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeCustomParameter = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(adminNoteIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordCons(choicesIsSymbol)(Data$dMap$dOrdered.udecodeMap(unscrambleDecodeCustomParameterChoice)(Data$dUUID.udecodeUUID)(Data$dOrd.ordString))(Unscramble.decodeRecordCons(defaultChoiceIsSymbol)(Unscramble.decodeMaybe(Data$dUUID.udecodeUUID))(Unscramble.decodeRecordCons(divisibleIsSymbol)(Unscramble.decodeBoolean1)(decodeRecordCons(Unscramble.decodeRecordNil))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeCustomParameterChoice = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericCustomParameterChoice)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(CustomParameterChoiceIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(photoIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") {
          return Foreign$dGeneric$dClass.genericEncodeConstructor(Restaumatic$dMenu$dV2$dTypes$dPhoto.PhotoIsSymbol)({
            encodeArgs: opts => v$1 => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v$1), Data$dList$dTypes.Nil)
          }).encodeOpts(Foreign$dEncoding.options)(v2._1);
        }
        $runtime.fail();
      }
    }))(nameIsSymbol)(encodeWithOptionsOther))(availableWhenIsSymbol)((() => {
      const encode1 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.encodeParametric(Foreign$dGeneric$dClass.booleanEncode)({
        encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
      }).encode;
      return {encodeWithOptions: v => encode1};
    })()))(availabilityIsSymbol)({encodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dAvailability.encodeAvailability.encode});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeCustomParameter = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericCustomParameter)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(CustomParameterIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(nameIsSymbol)(encodeWithOptionsOther))(divisibleIsSymbol)(encodeWithOptionsOther1))(defaultChoiceIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))(choicesIsSymbol)((() => {
      const encode1 = Data$dMap$dOrdered.encodeMap({
        encode: Foreign$dEncoding.defaultEncode(Data$dTuple$dT2.genericT2)(Foreign$dGeneric$dClass.genericEncodeConstructor(Data$dTuple$dT2.T2IsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsProduct({
          encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
        })({encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", encodeCustomParameterChoice.encode(v)), Data$dList$dTypes.Nil)})))
      }).encode;
      return {encodeWithOptions: v => encode1};
    })()))(adminNoteIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeCustomParameterChoice = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericCustomParameterChoice)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(CustomParameterChoiceIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(photoIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dMenu$dV2$dTypes$dPhoto.decodePhoto.decode)
  })())(nameIsSymbol)(decodeWithOptionsOther)())(availableWhenIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.decodeParametric(Foreign$dGeneric$dClass.booleanDecode)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument(decodeWithOptionsOther1),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    }).decode;
    return {decodeWithOptions: v => decode2};
  })())())(availabilityIsSymbol)({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dAvailability.decodeAvailability.decode})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeCustomParameter = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericCustomParameter)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(CustomParameterIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(nameIsSymbol)(decodeWithOptionsOther)())(divisibleIsSymbol)(decodeWithOptionsOther1)())(defaultChoiceIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Data$dUUID.decodeUUID.decode)
  })())(choicesIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Data$dMap$dOrdered.decodeMap(Data$dTuple$dT2.decodeT2({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    })({decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => decodeCustomParameterChoice.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing}))(Data$dOrd.ordString).decode;
    return {decodeWithOptions: v => decode2};
  })())())(adminNoteIsSymbol)({decodeWithOptions: v => Foreign$dGeneric$dClass.readString})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  CustomParameter,
  CustomParameterChoice,
  CustomParameterChoiceIsSymbol,
  CustomParameterIsSymbol,
  adminNoteIsSymbol,
  availabilityIsSymbol,
  availableWhenIsSymbol,
  choicesIsSymbol,
  decodeCustomParameter,
  decodeCustomParameterChoice,
  decodeRecordCons,
  decodeWithOptionsOther,
  decodeWithOptionsOther1,
  defaultChoiceIsSymbol,
  divisibleIsSymbol,
  encodeCustomParameter,
  encodeCustomParameterChoice,
  encodeWithOptionsOther,
  encodeWithOptionsOther1,
  eq1,
  eq2,
  eq7,
  eqCustomParameter,
  eqCustomParameterChoice,
  genericCustomParameter,
  genericCustomParameterChoice,
  hasFieldCustomParameter,
  hasFieldCustomParameterCh,
  nameIsSymbol,
  newtypeCustomParameterCho,
  newtypeCustomParameter_,
  photoIsSymbol,
  showCustomParameter,
  showCustomParameterChoice,
  showTranslated,
  toFillFormTypeCustomParam,
  toFillFormTypeCustomParam1,
  unscrambleDecodeCustomParameter,
  unscrambleDecodeCustomParameterChoice
};
